import GetShopSupplierByIdRequestModelBase from '../_generated/modelBases/get-shop-supplier-by-id-request-model-base';

export default class GetShopSupplierByIdRequestModel extends GetShopSupplierByIdRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
